module.exports = (promoCode) => `
  mutation {
    applyPromotionToCurrentOrder(promoCode: "${promoCode}") {
      messageType,
      messageText,
      order {
        number
        currency
        displayTotal
        items {
          sku
          variantId
          color
          groupName
          imageUrl
          price
          productPath
          productType
          quantity
          size
          stock
        }
        promotionAdjustment {
          code
          amount
          currency
        }
      }
    }
  }
`
